if (!customElements.get('toggle-description')) {
  class ToggleDescription extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('[data-toggle]');
      this.extra = this.querySelector('[data-extra]');
      this.showText = this.getAttribute('show-text') || 'Learn more';
      this.hideText = this.getAttribute('hide-text') || 'Close';
    }

    connectedCallback() {
      if (this.button && this.extra) {
        this.button.addEventListener('click', this.toggle.bind(this));
      }
    }

    toggle() {
      const isHidden = this.extra.hasAttribute('hidden');
      this.extra.toggleAttribute('hidden');
      this.button.textContent = isHidden ? this.hideText : this.showText;
    }
  }

  customElements.define('toggle-description', ToggleDescription);
}
